import React, { useEffect, useState } from "react";
import arrow from "../../assets/images/arrow.svg";
import { Link, useNavigate } from "react-router-dom";
import { Helmet } from "react-helmet";
import useRecaptcha from "../../hooks/useRecaptcha";
import { verifySite } from "../../utils/api";
const Orderplate = () => {
  const [selectedPlate, setSelectedPlate] = useState(
    "Standard (520mm x 111mm)"
  );

  const [registration, setRegistration] = useState("");
  const [selecttionString, setSelectionString] = useState("");
  const [plateSizeString, setplateSizeString] = useState("");
  const [selectedFont, setSelectedFont] = useState(null);
  const [registrationError, setRegistrationError] = useState("");
  const [typeError, setTypeError] = useState("");
  const [fontError, setFontError] = useState("");
  const [token] = useRecaptcha();
  const fontPrices = {
    1: 20.83,
    2: 41.66,
  };
  const [totalPrice, setTotalPrice] = useState(0);
  const navigate = useNavigate();

  // const handleRegistrationChange = (event) => {
  //   setRegistration(event.target.value);
  // };

  function isValidNumberPlatePrifix(plate) {
    try {
      // Create a pattern for the general structure of the number plate
      const pattern = /^[A-Z]\d{1,3}\s?[A-Z]{3}$/;

      // Check if the generated plate matches the expected pattern
      return pattern.test(plate);
    } catch (error) {
      // Handle any errors (e.g., invalid input)
      return false;
    }
  }
  function isValidNumberPlateSuffix(plate) {
    try {
      // Create a pattern for the general structure of the number plate
      const pattern = /^[A-Z]{3}\s?\d{1,3}[A-Z]$/;

      // Check if the generated plate matches the expected pattern
      return pattern.test(plate);
    } catch (error) {
      // Handle any errors (e.g., invalid input)
      return false;
    }
  }
  function isValidNumberPlateCurrent(plate) {
    try {
      // Create a pattern for the general structure of the number plate
      const pattern =
        /^[ABCDEFGHJKLMNOPRSTVWXY]{2}\d{2}\s?[ABCDEFGHJKLMNOPRSTVWXY]{3}$/;

      // Check if the generated plate matches the expected pattern
      return pattern.test(plate);
    } catch (error) {
      // Handle any errors (e.g., invalid input)
      return false;
    }
  }
  function isValidNumberPlateDateless(plate) {
    try {
      // Create a pattern for the general structure of the number plate
      const pattern = /^[A-Z]{1,5}\s?\d{1,5}$|^\d{1,5}\s?[A-Z]{1,5}$/;

      // Check if the generated plate matches the expected pattern
      return pattern.test(plate);
    } catch (error) {
      // Handle any errors (e.g., invalid input)
      return false;
    }
  }

  const handleRegistrationChange = (event) => {
    // const newRegistration = event.target.value.toUpperCase();
    const newRegistration = event.target.value.toUpperCase();
    setRegistration(newRegistration);
  };

  const handleFontSelection = (fontPrice) => {
    setSelectedFont(fontPrice);

    setTotalPrice(fontPrice);
  };

  // const handlePlateChange = (e) => {};

  // Define background image based on selectedPlate
  // const backgroundImage =
  //   selectedPlate === 'Standard' ? standardBackground : oversizedBackground;
  const handlesubmit = (e) => {
    e.preventDefault();

    if (!registration) {
      setRegistrationError("Please enter a registration");
      return;
    }
    if (!selecttionString) {
      setFontError("Please select a font");
      return;
    }

    if (typeError) {
      return;
    }
    verifySite(token);
    const formData = {
      registration: registration,
      totalPrice: totalPrice,
      plateString: selecttionString,
      plateSizeString: selectedPlate,
    };

    navigate("/orderplatecheckout", { state: { formData: formData } });
  };

  // const btnClick = () => {
  //   console.log('object');
  //   let plate = registration.trimStart();
  //   console.log('pl', plate);
  //   if (isValidNumberPlateDateless(plate)) {
  //     setRegistration(plate.replace(/([a-zA-Z])(\d)/g, '$1 $2'));
  //     console.log(
  //       "plate.replace(/([a-zA-Z])(d)/g, '$1 $2')",
  //       plate.replace(/([a-zA-Z])(\d)/g, '$1 $2'),
  //     );
  //   } else if (isValidNumberPlatePrifix(plate)) {
  //     setRegistration(
  //       plate.substring(0, plate.length - 3) + ' ' + plate.substring(plate.length - 3),
  //     );
  //   } else if (isValidNumberPlateSuffix(plate)) {
  //     setRegistration(plate.substring(0, 3) + ' ' + plate.substring(3));
  //   } else if (isValidNumberPlateCurrent(plate)) {
  //     setRegistration(
  //       plate.substring(0, plate.length - 3) + ' ' + plate.substring(plate.length - 3),
  //     );
  //   } else {
  //     const midpoint = Math.ceil(plate.length / 2);
  //     setRegistration(plate.substring(0, midpoint) + ' ' + plate.substring(midpoint));
  //   }

  //   // Check the type of the new registration plate
  // };

  const btnClick = () => {
    console.log("object");
    let plate = registration.trimStart();
    console.log("pl", plate);
    if (isValidNumberPlateDateless(plate)) {
      setTypeError("");
      if (!/\s/.test(plate)) {
        // Check if there's already a space
        setRegistration(plate.replace(/([a-zA-Z])(\d)/g, "$1 $2"));
      }
    } else if (isValidNumberPlatePrifix(plate)) {
      setTypeError("");
      if (!/\s/.test(plate)) {
        setRegistration(
          plate.substring(0, plate.length - 3) +
            " " +
            plate.substring(plate.length - 3)
        );
      }
    } else if (isValidNumberPlateSuffix(plate)) {
      setTypeError("");
      if (!/\s/.test(plate)) {
        setRegistration(plate.substring(0, 3) + " " + plate.substring(3));
      }
    } else if (isValidNumberPlateCurrent(plate)) {
      setTypeError("");
      if (!/\s/.test(plate)) {
        setRegistration(
          plate.substring(0, plate.length - 3) +
            " " +
            plate.substring(plate.length - 3)
        );
      }
    } else {
      if (registration) {
        setTypeError("Not a valid plate format");
      }
      // const midpoint = Math.ceil(plate.length / 2);
      // if (!/\s/.test(plate)) {
      //   setRegistration(
      //     plate.substring(0, midpoint) + " " + plate.substring(midpoint)
      //   );
      // }
    }

    // Check the type of the new registration plate
  };

  const totalAmount = Number(
    totalPrice +
      (selectedFont === 41.66 ? 8.33 : selectedFont === 20.83 ? 4.16 : 0.0)
  ).toFixed(2);

  return (
    <div className="main__page__content ">
      <Helmet>
        <meta charSet="utf-8" />
        <title>Buy Acrylic Number Plate</title>
      </Helmet>
      <main>
        <div className="reg__enquiry">
          <div className="reg__enquiry--data pt-45 pb-45">
            <div className="container">
              <h2 className="f36 fsi text-white">
                Prefer to order with us over the phone?{" "}
                <span className="text-green f36 fsi">
                  Call us on{" "}
                  <a className="text-green f36 fsi" href="tel:01582347734">
                    <u>
                      <b>01582 347734</b>
                    </u>
                  </a>
                </span>
              </h2>
            </div>
          </div>
        </div>
        {/*--*/}
        <section className="reg__plateorder--section">
          <div className="container">
            <div className="row plateorder__inner p-0 w-100 gap-4 gap-lg-0 mx-auto">
              <div className="reg__plateorder--left col-lg-8 p-0">
                <div className="plateorderleft__inner me-0 me-lg-4">
                  <div className="plateorder__heading">
                    <h1 className="f16 fys text-300 color-black lh24 reg__border position-relative">
                      Build your acrylic plates in 3 easy steps
                    </h1>
                  </div>
                  {/* Accordion */}
                  <div className="accordion" id="plateorderaccordion">
                    <div className="accordion-item">
                      <h2 className="accordion-header" id="headingOne">
                        <button
                          // onClick={() => btnClick()}
                          className="accordion-button"
                          type="button"
                          data-bs-toggle="collapse"
                          data-bs-target="#collapseOne"
                          aria-expanded="true"
                          aria-controls="collapseOne"
                        >
                          <h5 className="f16 fys text-black lh38 color-black">
                            1. Enter your reg
                          </h5>
                        </button>
                      </h2>
                      <div
                        id="collapseOne"
                        className="accordion-collapse collapse show"
                        aria-labelledby="headingOne"
                        data-bs-parent="#plateorderaccordion"
                      >
                        <div
                          className="accordion-body reg__makeoffer"
                          // onClick={() => btnClick()}
                        >
                          <h5 className="f16 fys text-black lh38 accordion__heading">
                            1. Enter your reg
                          </h5>
                          <div className="row accordion__wrapper gap-3 gap-md-0">
                            <div className="col-md-6">
                              <form action="" className="form me-3">
                                <label
                                  className="f16 mb-10 fsi text-400"
                                  htmlFor=""
                                >
                                  Registration :
                                  <span className="reg__iimportant f24">*</span>
                                </label>
                                <div className="input-group bgwhite-image enquiry__form">
                                  <input
                                    type="text"
                                    className="form-control p16 border-0 input"
                                    id="Registration"
                                    maxLength={8}
                                    value={registration}
                                    onChange={handleRegistrationChange}
                                    onBlur={btnClick}
                                  />
                                </div>
                                {typeError && (
                                  <div className="text-danger">{typeError}</div>
                                )}
                                {registrationError && (
                                  <p className="text-danger">
                                    {registrationError}
                                  </p>
                                )}
                              </form>
                            </div>
                            <div className="col-md-6 d-flex justify-content-md-end">
                              <ul className="accordion__list ps-4">
                                <li className="fsi f16">
                                  FREE 48 hour Royal Mail delivery
                                </li>
                                <li className="fsi f16">
                                  FREE premium fixing kit
                                </li>
                                <li className="fsi f16 set">
                                  Call 01582 347734 for more options if required
                                </li>
                              </ul>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    {/*-end*/}
                    <div className="accordion-item">
                      <h2 className="accordion-header" id="headingTwo">
                        <button
                          className="accordion-button collapsed"
                          type="button"
                          data-bs-toggle="collapse"
                          data-bs-target="#collapseTwo"
                          aria-expanded="false"
                          aria-controls="collapseTwo"
                        >
                          <h5 className="f16 fys text-black lh38">
                            2. Choose your rear plate size
                          </h5>
                        </button>
                      </h2>
                      <div
                        id="collapseTwo"
                        className="accordion-collapse collapse"
                        aria-labelledby="headingTwo"
                        data-bs-parent="#plateorderaccordion"
                      >
                        <div className="accordion-body reg__makeoffer">
                          <h5 className="f16 fys text-black lh38 accordion__heading">
                            2. Choose your rear plate size
                          </h5>
                          <div className="accordion__wrapper">
                            {/* {selectedPlate === 'Standard (520mm x 111mm)' && (
                              <p className="f15 fsi mb-2 mb-md-4 lh20">
                                Standard (520mm x 111mm)
                              </p>
                     
                            )} */}
                            {/* 
                            {selectedPlate ===
                              'Oversized - Suits Land Rover/ Range Rover (533mm x 152mm)' && (
                              <p className="f15 fsi mb-2 mb-md-4 lh20">
                                Oversized - Suits Land Rover/ Range Rover (533mm
                                x 152mm)
                              </p>
                            )} */}

                            <p className="f16 fsi mb-2 mb-md-4 lh20">
                              Front plate - Standard Car (520mmx111mm)
                            </p>

                            <form action="" className="form me-3">
                              <label
                                className="f16 mb-10 fsi text-400"
                                htmlFor=""
                              >
                                Rear plate :{" "}
                                <span className="reg__iimportant f24">*</span>
                              </label>
                              <div className="form_select">
                                <div className="d-flex align-center col-gap-10 mb-1">
                                  <input
                                    type="radio"
                                    name="choose-plate-size"
                                    id="first"
                                    value="Standard (520mm x 111mm)"
                                    // defaultValue="Standard (520mm x 111mm)"
                                    checked={
                                      selectedPlate ===
                                      "Standard (520mm x 111mm)"
                                    }
                                    onChange={(e) => {
                                      setplateSizeString(
                                        "Standard (520mm x 111mm)"
                                      );
                                      setSelectedPlate(e.target.value);
                                    }}
                                  />
                                  <label
                                    htmlFor="first"
                                    className="fys f16 text-300"
                                  >
                                    Standard (520mm x 111mm)
                                  </label>
                                </div>
                                <div className="d-flex align-center col-gap-10 mb-1">
                                  <input
                                    type="radio"
                                    name="choose-plate-size"
                                    id="second"
                                    value="Oversized - Suits Land Rover/ Range Rover (533mm x 152mm)"
                                    checked={
                                      selectedPlate ===
                                      "Oversized - Suits Land Rover/ Range Rover (533mm x 152mm)"
                                    }
                                    onChange={(e) => {
                                      setplateSizeString(
                                        "Oversized - Suits Land Rover/ Range Rover (533mm x 152mm)"
                                      );

                                      setSelectedPlate(e.target.value);
                                    }}
                                    // defaultValue="Oversized - Suits Land Rover/ Range Rover (533mm x 152mm)"
                                  />
                                  <label
                                    htmlFor="second"
                                    className="fys f16 text-300"
                                  >
                                    Oversized - Suits Land Rover/ Range Rover
                                    (533mm x 152mm)
                                  </label>
                                </div>
                              </div>
                            </form>
                          </div>
                        </div>
                      </div>
                    </div>
                    {/*-end*/}
                    <div className="accordion-item">
                      <h2 className="accordion-header" id="headingThree">
                        <button
                          className="accordion-button collapsed"
                          type="button"
                          data-bs-toggle="collapse"
                          data-bs-target="#collapseThree"
                          aria-expanded="false"
                          aria-controls="collapseThree"
                        >
                          <h5 className="f16 fys text-black lh38">
                            3. Choose your font
                          </h5>
                        </button>
                      </h2>
                      <div
                        id="collapseThree"
                        className="accordion-collapse collapse"
                        aria-labelledby="headingTwo"
                        data-bs-parent="#plateorderaccordion"
                      >
                        <div className="accordion-body reg__makeoffer">
                          <h5 className="f16 fys text-black lh38 accordion__heading">
                            3. Choose your font
                          </h5>
                          <div className="accordion__wrapper">
                            <form action="" className="form me-3">
                              <div className="row">
                                <div className="col-md-6 ref__font--data d-flex justify-content-center">
                                  <div className="orderplate_card_area w-100 position-relative">
                                    <input
                                      className="orderplate_checkbox"
                                      type="radio"
                                      name="choose-font"
                                      id={1}
                                      // defaultValue={1}
                                      onChange={() => {
                                        setSelectionString(
                                          "Standard 2D (printed) £24.99"
                                        );
                                        handleFontSelection(fontPrices[1]);
                                      }}
                                    />
                                    <div className="order_plate_card card1">
                                      <div className="order_plate_content">
                                        <div className="order_plate_image position-relative overflow-hidden">
                                          <img
                                            // src="./assets/images/orderplateimg1.png"
                                            src={require("../../assets/images/orderplateimg1.png")}
                                            alt=""
                                            width=""
                                            height=""
                                            className="img1 position-absolute top-0 start-0 end-0 bottom-0 object-fit-cover h-100 w-100"
                                          />
                                        </div>
                                        <div className="order_plate_title">
                                          <h6 className="f15 fys text-300 text-center d-flex align-items-center justify-content-center gap-2">
                                            Standard 2D (printed)
                                          </h6>
                                          <span className="f15 fys text-300 text-center price mt-10 w-100 d-block">
                                            £24.99
                                          </span>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                                <div className="col-md-6 d-flex ref__font--data justify-content-center">
                                  <div className="orderplate_card_area w-100 position-relative">
                                    <input
                                      className="orderplate_checkbox"
                                      type="radio"
                                      name="choose-font"
                                      id={2}
                                      // defaultValue={2}
                                      onChange={() => {
                                        handleFontSelection(fontPrices[2]);
                                        setSelectionString(
                                          "New 4D (3mm raised) £49.99"
                                        );
                                      }}
                                    />
                                    <div className="order_plate_card card2">
                                      <div className="order_plate_content">
                                        <div className="order_plate_image position-relative overflow-hidden">
                                          <img
                                            src={require("../../assets/images/4d.png")}
                                            alt=""
                                            width=""
                                            height=""
                                            className="img1 position-absolute top-0 start-0 end-0 bottom-0 object-fit-cover h-100 w-100"
                                          />
                                        </div>
                                        <div className="order_plate_title">
                                          <h6 className="f15 fys text-300 text-center d-flex align-items-center justify-content-center gap-2">
                                            New 4D (3mm raised)
                                          </h6>
                                          <span className="f15 fys text-300 text-center price mt-10 w-100 d-block">
                                            £49.99
                                          </span>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                              {fontError && (
                                <p className="text-danger">{fontError}</p>
                              )}
                            </form>
                          </div>
                        </div>
                      </div>
                    </div>
                    {/*-end*/}
                  </div>
                  {/*-end*/}
                  <div className="reg__section--bottom">
                    <p className="f20 lh20 mb-15 color-black fsi">
                      It really is that simple!
                    </p>
                    <p className="f16 lh20 mb-15 color-black fsi">
                      All of our plates come with FREE 48 hour tracked Royal
                      Mail delivery and a FREE Premium fixing kit as standard.
                      The fixing kit includes the following:
                    </p>
                    <ul className="reg-bottom-list disc ps-4 mb-2">
                      <li className="fsi color-black">
                        6 Double sided sticky pads
                      </li>
                      <li className="fsi color-black">5 Coated screws</li>
                      <li className="fsi color-black">
                        4 Black screw cap covers
                      </li>
                      <li className="fsi color-black">
                        2 White screw cap covers
                      </li>
                      <li className="fsi color-black">
                        2 Yellow screw cap covers
                      </li>
                    </ul>
                    <p className="orderplate__text fsi mt-4 mb-0 text-bold">
                      Please note we do offer more plate sizes, borders and
                      badges if you can't see exactly what you are looking for.
                      Call us on 01582 347734 and we can help.
                    </p>
                  </div>
                </div>
              </div>
              <div className="reg__plateorder--right col-lg-4 p-0 d-flex justify-content-end">
                <div className="plateorderright__inner plateorder__preview w-100">
                  <div className="reg__makeoffer reg__newmakeoffer">
                    <h5 className="f16 fys lh38">Preview</h5>
                    <div className="plateorder-billing-wrapper">
                      <div className="plateorder__top d-flex flex-column align-items-center row-gap-20">
                        <div className="plateOrder name1 w-100 text-center mb-20">
                          <img
                            src={require("../../assets/images/plateorderimg1.jpg")}
                            alt=""
                            className="w-100 h-100"
                          />
                          <h2 className="fun f60 text-center position-absolute">
                            {registration}
                          </h2>
                        </div>
                        <div
                          className="plateOrder name2 w-100 text-center"
                          onClick={() => btnClick()}
                        >
                          {selectedPlate === "Standard (520mm x 111mm)" ? (
                            <img
                              src={require("../../assets/images/plateorderimg2.jpg")}
                              alt=""
                              className="w-100 h-100"
                            />
                          ) : (
                            <img
                              src={require("../../assets/images/Oversize_Rear.png")}
                              alt=""
                              className="w-100 h-100"
                            />
                          )}
                          {/* <img
                            src={require('../../assets/images/plateorderimg2.jpg')}
                            alt=""
                            className="w-100 h-100"
                          /> */}
                          <h2 className="fun f60 text-center position-absolute">
                            {registration}
                          </h2>
                        </div>
                        <div className="plateOrder__info mt-4">
                          <p className="f12 fsi m-0 silver-text">
                            Image shown is for illustration purposes only.
                          </p>
                        </div>
                      </div>
                      <div className="reg__plate--title">
                        <div className="reg__price--line mt-0 mb-28" />
                        <div className="d-flex justify-content-between align-items-center">
                          <p className="f15 m-0 fsi lh24">Price:</p>
                          <p className="f20 price_show fsi m-0 lh24">
                            £{totalPrice.toFixed(2)}
                          </p>
                        </div>
                        {selectedFont === 41.66 && (
                          <div>
                            <div className="reg__price--line mt-28 mb-28" />
                            <div className="d-flex justify-content-between align-items-center">
                              <p className="f15 m-0 fsi lh24">VAT</p>
                              <p className="f20 price_show fsi m-0 lh24">
                                £8.33
                              </p>
                            </div>
                          </div>
                        )}
                        {selectedFont === 20.83 && (
                          <div>
                            <div className="reg__price--line mt-28 mb-28" />
                            <div className="d-flex justify-content-between align-items-center">
                              <p className="f15 m-0 fsi lh24">VAT</p>
                              <p className="f20 price_show fsi m-0 lh24">
                                £4.16
                              </p>
                            </div>
                          </div>
                        )}
                        <div className="reg__price--line mt-28 mb-28" />
                        <div className="d-flex justify-content-between align-items-center">
                          <p className="f15 m-0 fsi lh24">
                            Royal Mail 48 hour tracked delivery
                          </p>
                          <p className="f20 price_show fsi m-0 lh24">FREE</p>
                        </div>
                        <div className="reg__price--line mt-28 mb-28" />
                        <div className="d-flex justify-content-between align-items-center">
                          <p className="f15 m-0 fsi lh24">Premium fixing kit</p>
                          <p className="f20 price_show fsi m-0 lh24">FREE</p>
                        </div>
                        <div className="reg__price--line mt-28 mb-28" />
                        <div className="d-flex justify-content-between align-items-center">
                          <p className="f15 m-0 fsi lh24">Total Price: </p>
                          <p className="f20 price_show fsi m-0 lh24">
                            £{totalAmount}
                          </p>
                        </div>
                        <div className="reg__price--line mt-28 mb-28" />
                        <div className="reg__plateorder--button mt-4">
                          <div className="reg__checkout--button fsi">
                            <div className="offer-btn process-btn">
                              <button
                                // href="#"
                                className="d-flex align-center text-white w-100 justify-center btn_bord"
                                onClick={handlesubmit}
                              >
                                PROCEED TO CHECKOUT{" "}
                                <img className="in-svg" src={arrow} />
                              </button>
                            </div>
                          </div>
                        </div>
                        <div className="reg__payment--image d-flex justify-between mt-28">
                          <img
                            src={require("../../assets/images/mastervisa.png")}
                            alt="image"
                          />
                          <img
                            src={require("../../assets/images/reviews.png")}
                            alt="image"
                          />
                          <img
                            src={require("../../assets/images/poweredbystripe.png")}
                            alt="image"
                          />
                        </div>
                        <div className="reg__payment--note mt-28">
                          <p className="f16 text-700 fsi lh24 reg__iimportant mb-18 black-text">
                            IMPORTANT NOTE
                          </p>
                          <p className="f16 fsi lh24 black-text">
                            We will need to see the following documents to
                            complete your order:
                          </p>
                          <p className="f16 text-700 fsi lh24 black-text">
                            1x proof of address (this must match the delivery
                            address and be issued within the last 6 months) one
                            of the examples below:
                          </p>
                          <ul className="reg__note--list disc ps-4 black-text mb-18">
                            <li className="fsi black-text">Driving licence</li>
                            <li className="fsi black-text">
                              Utility bill (Gas, Water or Electric)
                            </li>
                            <li className="fsi black-text">Council tax bill</li>
                            <li className="fsi black-text">
                              Phone or Internet bill
                            </li>
                            <li className="fsi black-text">
                              Bank / mortgage statement
                            </li>
                          </ul>
                          <p className="f16 text-700 fsi lh24 black-text mt-3">
                            1x proof of ownership / entitlement (one of the
                            examples below)
                          </p>
                          <ul className="reg__note--list disc ps-4 black-text">
                            <li className="fsi black-text">
                              Vehicle logbook (V5c)
                            </li>
                            <li className="fsi black-text">
                              Retention Certificate (V778)
                            </li>
                            <li className="fsi black-text">
                              Certificate of Entitlement (V750)
                            </li>
                            <li className="fsi black-text">
                              New keeper supplement (green slip)
                            </li>
                            <li className="fsi black-text">
                              Letter of authorisation from a lease or hire
                              company
                            </li>
                            <li className="fsi black-text">
                              View Vehicle Record document (VVR) from a lease or
                              hire company
                            </li>
                            <li className="fsi black-text">
                              Vehicle tax / SORN reminder form (V11)
                            </li>
                          </ul>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </main>
    </div>
  );
};

export default Orderplate;
